import { getProjectSocialAccounts } from "@radarly/core/social";
import { useCurrentProject } from "./useCurrentProject";

export function useCurrentProjectSocialAccounts(
  platforms = [],
  relations = ["me"]
) {
  const currentProject = useCurrentProject();
  return getProjectSocialAccounts(currentProject, platforms, relations);
}
